import React, { type ComponentPropsWithoutRef } from 'react';
import { useEntryPointSubscription } from '@atlassian/jira-entry-point-subscription/src/index.tsx';
import type { AnyEntryPoint } from '@atlassian/jira-entry-point/src/common/types.tsx';
import type { EntryPointReferenceSubject } from '@atlassian/jira-entry-point/src/controllers/utils/use-entry-point-load-manager/index.tsx';
import { InternalEntryPointContainer } from '@atlassian/jira-internal-entry-point-container/src/index.tsx';

export interface Props<TEntryPoint extends AnyEntryPoint>
	extends Omit<
		ComponentPropsWithoutRef<typeof InternalEntryPointContainer<TEntryPoint>>,
		'entryPointReference'
	> {
	entryPointReferenceSubject: EntryPointReferenceSubject<TEntryPoint>;
}

export const JiraEntryPointContainer = <TEntryPoint extends AnyEntryPoint>({
	entryPointReferenceSubject,
	...containerProps
}: Props<TEntryPoint>) => {
	const entryPointReference = useEntryPointSubscription<TEntryPoint>(entryPointReferenceSubject);

	return entryPointReference ? (
		<InternalEntryPointContainer
			{...containerProps}
			entryPointReference={entryPointReference}
			placeholderName="jira-entry-point-container"
		/>
	) : null;
};

export const NestedEntryPointContainer = InternalEntryPointContainer;
